module.exports = __webpack_public_path__ + "img/service.24ab0be9.svg";